<script lang="ts" generics="TValues">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import { query } from '$lib/apollo/SvelteApollo';
    import { HashtagsQueryDocument, type HashtagsQueryQuery } from '$gql/graphql';
    import { type ComboboxOptionProps } from '@melt-ui/svelte';
    import type { IterableElement } from 'type-fest';
    import SearchHeaderComboxbox from '$components/SearchHeader/SearchHeaderComboxbox.svelte';
    import MobileModalCombobox, {
        createDialog,
    } from '$components/SearchHeader/MobileModalCombobox.svelte';
    import MobileButton from '$components/SearchHeader/MobileButton.svelte';
    import StackZIndex from '$components/ZIndex/StackZIndex.svelte';
    import { readable } from 'svelte/store';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, string | null>;
    export let style: 'desktop' | 'desktop-full' | 'mobile';

    const q = form.stores().fieldValue(field);

    const label = `Hashtag`;
    const placeholder = '#';

    let skip = true;
    $: response = skip
        ? { result: readable(null), setVariables: null }
        : query(HashtagsQueryDocument, {
              variables: { q: $q ?? '' },
          });
    $: ({ result, setVariables } = response);
    $: setVariables?.({ q: $q ?? '' });
    $: items =
        ($q ?? '').trim() === '' ? [] : ($result?.data?.searchHeader.hashtags ?? []);

    function toOption(
        item: IterableElement<HashtagsQueryQuery['searchHeader']['hashtags']>,
    ): ComboboxOptionProps<string> {
        return { value: item, label: item };
    }

    const giveFocusToField = (event: MouseEvent) => {
        if (event.target instanceof HTMLElement) {
            if (event.target.tagName === 'DIV') {
                const input = document.getElementById(form.getFieldId(field));
                input?.click();
                input?.focus();
            }
        }
    };

    const mobileDialog = createDialog(form, field, {});

    function onItemCanBeLoaded() {
        skip = false;
    }
</script>

{#if style === 'mobile'}
    <div class="flex">
        <div class="flex-auto">
            <MobileButton
                {form}
                queryField={field}
                {label}
                placeholder="#"
                dialog={mobileDialog}
                withSearch={false}
            />
        </div>

        <MobileModalCombobox
            {form}
            queryField={field}
            itemField={field}
            {items}
            {toOption}
            dialog={mobileDialog}
            {label}
            {placeholder}
            {onItemCanBeLoaded}
        >
            <svelte:fragment slot="item" let:item>
                <span>{item}</span>
            </svelte:fragment>
        </MobileModalCombobox>
    </div>
{:else}
    <!-- svelte-ignore a11y-no-static-element-interactions a11y-click-events-have-key-events -->
    <div
        class="h-[64px] rounded-l-[50px] bg-white flex-1 cursor-pointer flex"
        on:click|trusted={giveFocusToField}
    >
        <StackZIndex zIndex="current" let:zIndex>
            <SearchHeaderComboxbox
                {form}
                queryField={field}
                {items}
                {toOption}
                {label}
                {placeholder}
                zIndex={zIndex - 1}
                thinLeftPad={false}
                {onItemCanBeLoaded}
            >
                <svelte:fragment slot="item" let:item>
                    <span>{item}</span>
                </svelte:fragment>
            </SearchHeaderComboxbox>
        </StackZIndex>
    </div>
{/if}
